import styled, { css } from "styled-components";

export const Alert = styled.div`
  display: flex;
  align-items: center;
  gap: 5.3px;

  ${({ type }) => {
    switch (type) {
      case "error":
        return css`
          ${AlertIcon} svg * {
            fill: ${({ theme }) => theme.colors.feedbackState.critical.default};
          }
          ${AlertText} {
            color: ${({ theme }) =>
              theme.colors.feedbackState.critical.default};
          }
        `;
      case "warning":
        return css`
          ${AlertIcon} svg * {
            fill: ${({ theme }) => theme.colors.feedbackState.warning.default};
          }
          ${AlertText} {
            color: ${({ theme }) => theme.colors.feedbackState.warning.default};
          }
        `;
      case "success":
        return css`
          ${AlertIcon} svg * {
            fill: ${({ theme }) => theme.colors.feedbackState.success.default};
          }
          ${AlertText} {
            color: ${({ theme }) => theme.colors.feedbackState.success.default};
          }
        `;
      default:
        return css`
          ${AlertIcon} svg * {
            fill: ${({ theme }) => theme.colors.neutral.gray4};
          }
          ${AlertText} {
            color: ${({ theme }) => theme.colors.neutral.gray4};
          }
        `;
    }
  }}

  ${({ size }) => {
    switch (size) {
      case "xs":
        return css`
          ${AlertText} {
            ${({ theme }) => theme.font.body.x};
          }
        `;
      case "sm":
        return css`
          ${AlertText} {
            ${({ theme }) => theme.font.body.sm};
          }
        `;
      default:
      case "md":
        return css`
          ${AlertText} {
            ${({ theme }) => theme.font.body.md};
          }
        `;
      case "lg":
        return css`
          ${AlertText} {
            ${({ theme }) => theme.font.body.lg};
          }
        `;
    }
  }}
`;

export const AlertIcon = styled.i``;

export const AlertText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: red;
`;
